import { OIDBalanceLoanDetails } from './OIDBalanceLoanDetails';

export default OIDBalanceLoanDetails;
